import { render, staticRenderFns } from "./saima.vue?vue&type=template&id=61b66f2e&scoped=true"
import script from "./saima.vue?vue&type=script&lang=js"
export * from "./saima.vue?vue&type=script&lang=js"
import style0 from "./saima.vue?vue&type=style&index=0&id=61b66f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b66f2e",
  null
  
)

export default component.exports